<template>
  <v-container class="information-page py-6" fluid>
    <v-row justify="center">
      <v-col cols="12" md="9" lg="7" xl="6">
        <v-card class="information-card" elevation="2">
          <!-- Header -->
          <div class="information-header">
            <div class="information-title-block">
              <div class="information-title-icon">
                <v-icon color="primary" size="28">
                  mdi-email-outline
                </v-icon>
              </div>

              <div>
                <h1 class="information-title">
                  Kontakt
                </h1>

                <p class="information-subtitle">
                  Nehmen Sie Kontakt mit uns auf
                </p>
              </div>
            </div>
          </div>

          <v-divider />

          <!-- Content -->
          <v-card-text class="information-content">
            <!-- Company details -->
            <section class="contact-section">
              <div class="section-heading">
                <v-icon color="primary" size="22">
                  mdi-office-building-outline
                </v-icon>

                <span>Unternehmen</span>
              </div>

              <!-- Company name -->
              <div class="contact-row">
                <div class="contact-row-icon">
                  <v-icon color="primary">
                    mdi-domain
                  </v-icon>
                </div>

                <div>
                  <div class="contact-label">
                    Unternehmen
                  </div>

                  <div class="contact-value font-weight-bold">
                    Rud. Otto Meyer Technik GmbH &amp; Co. KG
                  </div>
                </div>
              </div>

              <!-- Address -->
              <div class="contact-row">
                <div class="contact-row-icon">
                  <v-icon color="primary">
                    mdi-map-marker-outline
                  </v-icon>
                </div>

                <div>
                  <div class="contact-label">
                    Anschrift
                  </div>

                  <address class="contact-value">
                    Tilsiter Straße 162<br />
                    22047 Hamburg
                  </address>
                </div>
              </div>
            </section>

            <!-- Contact options -->
            <section class="contact-section">
              <div class="section-heading">
                <v-icon color="primary" size="22">
                  mdi-card-account-phone-outline
                </v-icon>

                <span>Kontaktmöglichkeiten</span>
              </div>

              <!-- Phone -->
              <a href="tel:+494069491400">
                <div class="contact-action-icon">
                  <v-icon color="primary">
                    mdi-phone-outline
                  </v-icon>
                </div>

                <div class="contact-action-content">
                  <div class="contact-label">
                    Telefon
                  </div>

                  <div class="contact-value">
                    +49 40 6949-1400
                  </div>
                </div>

                <v-icon
                  class="contact-action-arrow"
                  size="20"
                >
                  mdi-open-in-new
                </v-icon>
              </a>

              <!-- Email -->
              <a
                href="mailto:earns@rom-technik.de"
                class="contact-action"
                aria-label="E-Mail an das EARNS-Team senden"
              >
                <div class="contact-action-icon">
                  <v-icon color="primary">
                    mdi-email-outline
                  </v-icon>
                </div>

                <div class="contact-action-content">
                  <div class="contact-label">
                    E-Mail
                  </div>

                  <div class="contact-value">
                    earns@rom-technik.de
                  </div>
                </div>

                <v-icon
                  class="contact-action-arrow"
                  size="20"
                >
                  mdi-open-in-new
                </v-icon>
              </a>
            </section>
          </v-card-text>

          <v-divider />

          <!-- Footer actions -->
          <div class="information-footer">
            <v-btn
              color="primary"
              variant="tonal"
              :to="{ name: 'Home' }"
            >
              <v-icon start>
                mdi-home-outline
              </v-icon>

              Zur Startseite
            </v-btn>

            <v-btn
              color="primary"
              variant="elevated"
              href="mailto:earns@rom-technik.de?subject=EARNS-Anfrage"
            >
              <v-icon start>
                mdi-email-send-outline
              </v-icon>

              E-Mail schreiben
            </v-btn>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped lang="scss">
.information-page {
  min-height: 100%;
}

.information-card {
  overflow: hidden;

  border: 1px solid rgba(var(--v-theme-on-surface), 0.08);
  border-radius: 28px;

  color: rgb(var(--v-theme-on-surface));
  background-color: rgb(var(--v-theme-surface));
}

/* Header */
.information-header {
  padding: 1.25rem 1.5rem;

  background: linear-gradient(
    180deg,
    rgba(var(--v-theme-primary), 0.07),
    rgba(var(--v-theme-primary), 0.025)
  );
}

.information-title-block {
  display: flex;
  align-items: center;
  gap: 0.9rem;
}

.information-title-icon {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;

  width: 48px;
  height: 48px;
  border-radius: 999px;

  background-color: rgba(var(--v-theme-primary), 0.09);
}

.information-title {
  margin: 0;

  color: rgb(var(--v-theme-on-surface));

  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1.25;
}

.information-subtitle {
  margin: 0.15rem 0 0;

  color: rgba(var(--v-theme-on-surface), 0.62);

  font-size: 0.82rem;
  line-height: 1.4;
}

/* Content */
.information-content {
  display: grid;
  gap: 1.25rem;

  padding: 1.5rem;
}

.contact-section {
  padding: 1rem;

  border: 1px solid rgba(var(--v-theme-on-surface), 0.07);
  border-radius: 22px;

  background-color: rgba(var(--v-theme-primary), 0.025);
}

.section-heading {
  display: flex;
  align-items: center;
  gap: 0.55rem;

  margin-bottom: 1rem;
  padding-bottom: 0.75rem;

  border-bottom: 1px solid
    rgba(var(--v-theme-on-surface), 0.07);

  color: rgb(var(--v-theme-primary));

  font-size: 0.95rem;
  font-weight: 700;
}

/* Contact information */
.contact-row {
  display: flex;
  align-items: flex-start;
  gap: 0.8rem;

  padding: 0.75rem 0;
}

.contact-row + .contact-row {
  border-top: 1px solid
    rgba(var(--v-theme-on-surface), 0.06);
}

.contact-row-icon,
.contact-action-icon {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;

  width: 40px;
  height: 40px;
  border-radius: 999px;

  background-color: rgba(var(--v-theme-primary), 0.09);
}

.contact-label {
  margin-bottom: 0.15rem;

  color: rgba(var(--v-theme-on-surface), 0.58);

  font-size: 0.75rem;
  font-weight: 600;
}

.contact-value {
  margin: 0;

  color: rgb(var(--v-theme-on-surface));

  font-size: 0.92rem;
  line-height: 1.5;
  font-style: normal;
}

/* Clickable contact options */
.contact-action {
  display: flex;
  align-items: center;
  gap: 0.8rem;

  padding: 0.75rem;

  border: 1px solid transparent;
  border-radius: 16px;

  color: inherit;
  text-decoration: none;

  transition:
    border-color 160ms ease,
    background-color 160ms ease,
    transform 160ms ease;
}

.contact-action + .contact-action {
  margin-top: 0.4rem;
}

.contact-action:hover {
  border-color: rgba(var(--v-theme-primary), 0.16);
  background-color: rgba(var(--v-theme-primary), 0.055);
  transform: translateX(2px);
}

.contact-action-content {
  flex: 1 1 auto;
  min-width: 0;
}

.contact-action-arrow {
  flex-shrink: 0;
  color: rgba(var(--v-theme-on-surface), 0.48);
}

/* Footer */
.information-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem;

  padding: 1rem 1.5rem;
}

.information-footer .v-btn {
  font-weight: 600;
  text-transform: none;
}

/* Responsive */
@media (max-width: 700px) {
  .information-page {
    padding-inline: 0.5rem;
  }

  .information-header {
    padding: 1rem;
  }

  .information-title-block {
    align-items: flex-start;
  }

  .information-title-icon {
    width: 42px;
    height: 42px;
  }

  .information-content {
    padding: 1rem;
  }

  .contact-section {
    padding: 0.8rem;
    border-radius: 19px;
  }

  .information-footer {
    align-items: stretch;
    flex-direction: column-reverse;

    padding: 1rem;
  }

  .information-footer .v-btn {
    width: 100%;
  }
}

@media (prefers-reduced-motion: reduce) {
  .contact-action {
    transition: none;
  }

  .contact-action:hover {
    transform: none;
  }
}
</style>

